import type React from "react";

import { useIntercom } from "src/hooks/useIntercom";

import { SideMenuLayout } from "../SideMenuLayout/SideMenuLayout";
import { useSimpleTopBarStyles } from "./SideMenuLayout.styles";

interface SimpleTopBarLayoutProps {
    children?: React.ReactNode;
}

function SimpleTopBarLayout({ children }: SimpleTopBarLayoutProps): JSX.Element {
    const classes = useSimpleTopBarStyles();

    useIntercom();

    return (
        <SideMenuLayout topBarProps={{ hasMinimalDisplay: true }} className={classes.root}>
            {children}
        </SideMenuLayout>
    );
}

export default SimpleTopBarLayout;
